module.exports = __webpack_public_path__ + "static/infernal_calling-5621583f3806d2a73052c2fbf258913b.jpg";